export class Phonnumberextractor
{
  public Export(text:string):string
  {
    if(!text || text == null || text.length == 0)
      return '';

    text = text.replace(/\D/g, '');
    var bereinigt = text.replace(/^0+/, '');
    if(!bereinigt.startsWith('49'))
      bereinigt = `49${bereinigt}`;

    return bereinigt;

  }
}
